import env from "react-dotenv";
import { ServiceCommon } from "./service.common";
import { isEmpty } from "../utilities/validators";
import { TFilter } from "../types/FilterType";
import { TPagination } from "../types/PaginationType";

class BnfService extends ServiceCommon {
    
    API_BNF = env.API_BNF;

    constructor() {
        super('BnfService');
    }

    /* BENEFIT */

    async benefitById(benefitId: number) {
        const url = `${this.API_BNF}/benefit/${benefitId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // benefitById

    async benefitList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // benefitList

    async benefitSearch(filter?: TFilter) {
        const url = `${this.API_BNF}/benefit/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter);
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // benefitSearch

    async saveBenefit(benefitId: number, benefit: any) {
        const url = `${this.API_BNF}/benefit/save/${benefitId}`;

        try {
            return await this.putReturnObject(url, benefit);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveBenefit

    async createBenefit(benefit: any) {
        const url = `${this.API_BNF}/benefit/create`;

        try {
            return await this.postReturnObject(url, benefit);
        } catch (error: any) {
            throw new Error(error);
        }
    }

    async benefitDeleteById(benefitId: number, comments: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_BNF}/benefit/delete/${benefitId}`;
        else
            url = `${this.API_BNF}/benefit/delete/${benefitId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // benefitDeleteById

    /* RULE */

    async ruleById(ruleId: number) {
        const url = `${this.API_BNF}/benefit_rule/${ruleId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // ruleById

    async ruleList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_rule/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // ruleList

    async ruleSearch(filter?: TFilter) {
        const url = `${this.API_BNF}/benefit_rule/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // ruleSearch

    async saveRule(ruleId: number, rule: any) {
        const url = `${this.API_BNF}/benefit_rule/save/${ruleId}`;

        try {
            return await this.putReturnObject(url, rule);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveRule

    async createRule(rule: any) {
        const url = `${this.API_BNF}/benefit_rule/create`;

        try {
            return await this.postReturnObject(url, rule);
        } catch (error: any) {
            throw new Error(error);
        }
    }

    async ruleDeleteById(ruleId: number, comments: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_BNF}/benefit_rule/delete/${ruleId}`;
        else
            url = `${this.API_BNF}/benefit_rule/delete/${ruleId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // ruleDeleteById

    /* RECIPIENT */

    async recipientById(recipientId: number, benefitId: number, ruleId: number) {
        const url = `${this.API_BNF}/benefit_recipient/${recipientId}/benefit/${benefitId}/rule/${ruleId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // recipientById

    async recipientList(benefitId: number, ruleId: number, attributes: string[], pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_recipient/list/benefit/${benefitId}/rule/${ruleId}`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // recipientList

    async recipientSearch(benefitId: number, ruleId: number, filter?: TFilter) {
        const url = `${this.API_BNF}/benefit_recipient/search/benefit/${benefitId}/rule/${ruleId}`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // recipientSearch

    async saveRecipient(recipientId: number, benefitId: number, ruleId: number, recipient: any) {
        const url = `${this.API_BNF}/benefit_recipient/save/${recipientId}/benefit/${benefitId}/rule/${ruleId}`;

        try {
            return await this.putReturnObject(url, recipient);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveRecipient

    async createRecipient(benefitId: number, ruleId: number, recipient: any) {
        const url = `${this.API_BNF}/benefit_recipient/create/benefit/${benefitId}/rule/${ruleId}`;

        try {
            return await this.postReturnObject(url, recipient);
        } catch (error: any) {
            throw new Error(error);
        }
    }

    async recipientDeleteById(recipientId: number, benefitId: number, ruleId: number, comments: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_BNF}/benefit_recipient/delete/${recipientId}/benefit/${benefitId}/rule/${ruleId}`;
        else
            url = `${this.API_BNF}/benefit_recipient/delete/${recipientId}/benefit/${benefitId}/rule/${ruleId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // recipientDeleteById

    /* PRESET */

    async presetById(benefitId: number) {
        const url = `${this.API_BNF}/benefit_preset/${benefitId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetById

    async presetListCategory(pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_preset/list/category`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetListCategory

    async presetListService(category: string, pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_preset/list/service`;

        try {
            const resultObject = await this.postReturnObject(url, { category, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetListService

    async presetListRegulation(category: string, pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_preset/list/regulation`;

        try {
            const resultObject = await this.postReturnObject(url, { category, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetListRegulation

    async presetListCondition(pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_preset/list/condition`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetListCondition

    async presetListAmount(category: string, pagination?: TPagination) {
        const url = `${this.API_BNF}/benefit_preset/list/amount`;

        try {
            const resultObject = await this.postReturnObject(url, { category, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // presetListAmount

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new BnfService();
